module.exports = __webpack_public_path__ + "img/vertical-bullets.e7b823b3.svg";